import { apigClient } from "@/shared/api";

export const companyService = {
  create,
  get,
  setLoginCompany
};

function create(bodyParams) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      var method = "POST";
      var pathTemplate = "/companies";
      var additionalParams = {};
      var pathParams = {};
      apigClient
        .invokeApi(
          pathParams,
          pathTemplate,
          method,
          additionalParams,
          bodyParams
        )
        .then(function(results) {
          var data = results["data"]["data"];
          return data;
        })
        .catch(function(err) {
          reject({
            error: true,
            text: () => Promise.resolve(JSON.stringify(err))
          });
        });
    });
  });
}

function get() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      var method = "GET";
      var pathTemplate = "/companies";
      var additionalParams = {};
      var pathParams = {};
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results) {
          that.logData = results["data"]["data"];
        })
        .catch(function(err) {
          reject({
            error: true,
            text: () => Promise.resolve(JSON.stringify(err))
          });
        });
    });
  });
}

function setLoginCompany(id) {
  setTimeout(() => {
    var method = "GET";
    var pathTemplate = "/companies/" + id;
    var additionalParams = {};
    var pathParams = {};
    apigClient
      .invokeApi(pathParams, pathTemplate, method, additionalParams)
      .then(function(results) {
        const data = results["data"]["data"];
        let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
        loginUserInfo.db.company.name = data.companyName;
        loginUserInfo.db.company.website = data.website;
        loginUserInfo.db.company.prefix = data.prefix;
        loginUserInfo.db.company.shortname = data.shortname;
        loginUserInfo.db.company.customerLocation = data.customerLocation;

        localStorage.setItem("loginUserInfo", JSON.stringify(loginUserInfo));
      })
      .catch(function(err) {
        console.log("ERROR ! Cannot get data:" + err);
      });
  });
}
